import { Column } from "@/components/Column";

import { PlayyardSky } from "@/types";

// Scene % positions (feet) and widths. Listed in lighting order: the patch
// lights up one by one across golden hour as the sun goes down.
const PUMPKINS = [
  { left: 22, top: 57.5, sizeCqw: 2 },
  { left: 8, top: 58.5, sizeCqw: 2.4 },
  { left: 52, top: 60.5, sizeCqw: 2.6 },
  { left: 97, top: 60, sizeCqw: 2.6 },
  { left: 30.5, top: 61, sizeCqw: 2.4 },
  // Tucked behind the flowers and wren in the bottom-left corner.
  { left: 2.5, top: 88, sizeCqw: 3.6 },
];

export const PlayyardPumpkinPatch = ({ sky }: { sky: PlayyardSky }) => {
  return (
    <>
      {PUMPKINS.map((pumpkin, index) => (
        <PlayyardPumpkin
          key={`${pumpkin.left.toString()}-${pumpkin.top.toString()}`}
          {...pumpkin}
          isLit={sky.eveningProgress > index / PUMPKINS.length}
        />
      ))}
    </>
  );
};

// No stacking context on the wrapper: the body sits on the lawn under the
// pets while its glow rises above the night tint so it reads as light.
const PlayyardPumpkin = ({
  left,
  top,
  sizeCqw,
  isLit,
}: {
  left: number;
  top: number;
  sizeCqw: number;
  isLit: boolean;
}) => {
  const position = {
    left: `${left.toString()}%`,
    top: `${top.toString()}%`,
    width: `${sizeCqw.toString()}cqw`,
  };

  return (
    <>
      <svg
        className="pointer-events-none absolute z-[7] -translate-x-1/2 -translate-y-full"
        style={position}
        viewBox="0 0 40 34"
      >
        <path d="M19 7 Q18 2 22 0 L23 2 Q21 4 21.5 7Z" fill="#4d5a2a" />
        <ellipse cx="11" cy="20" rx="10" ry="12.5" fill="#c75d1b" />
        <ellipse cx="29" cy="20" rx="10" ry="12.5" fill="#c75d1b" />
        <ellipse cx="20" cy="20" rx="11" ry="13.5" fill="#e8792b" />
        <path
          d="M20 7 Q15 20 20 33 M20 7 Q25 20 20 33"
          stroke="#c75d1b"
          strokeWidth="0.8"
          fill="none"
        />
        {isLit ? (
          <path
            className="staffer-pet-yard-flicker"
            d="M11 15 L15 19 L9 19Z M29 15 L31 19 L25 19Z M10 24 L13 26 L16 24 L20 27 L24 24 L27 26 L30 24 Q26 31 20 30.5 Q14 31 10 24Z"
            fill="#ffd36b"
          />
        ) : null}
      </svg>
      {/* Outer fades the glow on; inner flickers (both drive opacity). */}
      <Column
        className="pointer-events-none absolute z-[39] -translate-x-1/2 -translate-y-[70%] mix-blend-screen transition-opacity [transition-duration:1500ms]"
        style={{
          left: position.left,
          top: position.top,
          width: `${(sizeCqw * 2.6).toString()}cqw`,
          height: `${(sizeCqw * 2.6).toString()}cqw`,
          opacity: isLit ? 1 : 0,
        }}
      >
        <Column className="staffer-pet-yard-flicker h-full w-full rounded-full bg-[radial-gradient(circle,rgb(255_170_60_/_0.55),rgb(255_120_30_/_0.15)_45%,transparent_70%)]" />
      </Column>
    </>
  );
};
